var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"flex flex-align flex-center"},[_c('spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }